<p-toast></p-toast>

<app-page-shell>
  <app-page-hero eyebrow="CRM Contracts" [title]="templateId ? 'Edit Contract Template' : 'New Contract Template'" subtitle="Configure reusable rich text sections and approved placeholder tokens.">
    <div actions>
      <p-button label="Cancel" icon="fa-solid fa-xmark" severity="secondary" [outlined]="true" routerLink="/contracts/templates"></p-button>
      <p-button label="Save Template" icon="fa-solid fa-floppy-disk" [loading]="saving()" (onClick)="save()"></p-button>
    </div>
  </app-page-hero>

  <app-page-form-section icon="fa-solid fa-file-contract" title="Template Metadata" subtitle="Scope this template by contract type, job type, service line, and language.">
    <div class="form-grid">
      <p-inputGroup>
        <p-inputGroupAddon><i class="fa-solid fa-heading"></i></p-inputGroupAddon>
        <p-iftaLabel><input pInputText id="title" [(ngModel)]="template.title"><label for="title">Title</label></p-iftaLabel>
      </p-inputGroup>
      <p-inputGroup>
        <p-inputGroupAddon><i class="fa-solid fa-tags"></i></p-inputGroupAddon>
        <p-iftaLabel><input pInputText id="contractType" [(ngModel)]="template.contractType"><label for="contractType">Contract Type</label></p-iftaLabel>
      </p-inputGroup>
      <p-inputGroup>
        <p-inputGroupAddon><i class="fa-solid fa-briefcase"></i></p-inputGroupAddon>
        <p-iftaLabel><input pInputText id="jobType" [(ngModel)]="template.jobType"><label for="jobType">Job Type</label></p-iftaLabel>
      </p-inputGroup>
      <p-inputGroup>
        <p-inputGroupAddon><i class="fa-solid fa-language"></i></p-inputGroupAddon>
        <p-iftaLabel><input pInputText id="languageCode" [(ngModel)]="template.languageCode"><label for="languageCode">Language</label></p-iftaLabel>
      </p-inputGroup>
      <p-inputGroup>
        <p-inputGroupAddon><i class="fa-solid fa-code-branch"></i></p-inputGroupAddon>
        <p-iftaLabel><p-inputNumber inputId="version" [(ngModel)]="template.version" styleClass="w-full"></p-inputNumber><label for="version">Version</label></p-iftaLabel>
      </p-inputGroup>
      <label class="active-row"><p-checkbox [(ngModel)]="template.active" [binary]="true"></p-checkbox><span>Active</span></label>
    </div>
  </app-page-form-section>

  <app-page-form-section icon="fa-solid fa-layer-group" title="Template Sections" subtitle="Use whitelist placeholders such as {seller.companyName}, {buyer.companyName}, {quotation.number}, {revision.paymentTerms}, and {rateCard.table}.">
    <div class="section-actions"><p-button label="Add Section" icon="fa-solid fa-plus" severity="secondary" [outlined]="true" (onClick)="addSection()"></p-button></div>
    @for (section of sections(); track section.sectionKey) {
      <div class="template-section">
        <div class="section-grid">
          <p-inputGroup>
            <p-inputGroupAddon><i class="fa-solid fa-key"></i></p-inputGroupAddon>
            <p-iftaLabel><input pInputText [(ngModel)]="section.sectionKey" [id]="'key-' + section.sectionKey"><label [for]="'key-' + section.sectionKey">Section Key</label></p-iftaLabel>
          </p-inputGroup>
          <p-inputGroup>
            <p-inputGroupAddon><i class="fa-solid fa-heading"></i></p-inputGroupAddon>
            <p-iftaLabel><input pInputText [(ngModel)]="section.sectionTitle" [id]="'section-title-' + section.sectionKey"><label [for]="'section-title-' + section.sectionKey">Title</label></p-iftaLabel>
          </p-inputGroup>
        </div>
        <p-editor [(ngModel)]="section.sectionHtml" [style]="{ height: '220px' }"></p-editor>
      </div>
    }
  </app-page-form-section>
</app-page-shell>
